import Bowser from 'bowser';
import axios from 'axios';

const handleTelegramSupportClick = () => {
  const bowser = Bowser.getParser(window.navigator.userAgent);
  const supportButtons = document.querySelectorAll('[data-telegram-support]');
  const payload = {
    urlFrom: window.location.href,
    cityId: Number(window.params?.cityId),
    deviceType: bowser.getPlatformType(),
    osName: bowser.getOSName(),
    osVersion: bowser.getOSVersion(),
    browserName: bowser.getBrowserName(),
    browserVersion: bowser.getBrowserVersion(),
    userFrontendId: Number(window.userId) || undefined,
  };

  supportButtons.forEach((button) => {
    button.addEventListener('click', () => {
      /**
       * first we open an empty window,
       * and after the response from the API we change change the link
       * to bypass the pop-up blocker in the browser
       */
      const newWindow = window.open('', '_blank');
      /**
       * this request should only be sent after clicking on the link
       * because each request create new support session
       */
      axios({
        url: `/api/v2/telegram_support_request`,
        method: 'post',
        data: payload,
      })
        .then(({ data }) => {
          if (newWindow) {
            newWindow.location.href = `https://telegram.me/lun_support_bot?start=${data.supportRequestId}`;
          }
        })
        .catch(() => {
          if (newWindow) {
            newWindow.location.href = 'https://telegram.me/lun_support_bot?start=MTgyMjUwLnVr';
          }
        });
    });
  });
};

export default handleTelegramSupportClick;
